import { useDeleteSmsSnippetMutation } from "../../../../../../api/smsSnippets/useDeleteSmsSnippetMutation";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../services/UINotificationService";

export const useDelete = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets",
  });

  const { mutateAsync, isLoading } = useDeleteSmsSnippetMutation({
    onError: () => {
      uiNotification.error(t("error.deleteOne"));
    },
    onSuccess: () => {
      uiNotification.success(t("success.deleteOne"));
    },
  });

  return {
    initiate: (id) => mutateAsync({ id }),
    isLoading,
  };
};
